export function getLastMonthOfQuarter(month: number): number {
  // month 1..12 -> quarter end month 3,6,9,12
  return Math.ceil(month / 3) * 3;
}
